import utils from '@/mixins/utils.js'

/**
 * Faz o parse seguro do campo dados.
 *
 * @param {Object} item
 * @returns {Object}
 */
function getDados(item) {
  try {
    return typeof item.dados === 'string'
      ? JSON.parse(item.dados)
      : item.dados || {}
  } catch (error) {
    console.error('Erro ao fazer parse do campo dados:', error)
    return {}
  }
}

export const dataFields = {
  Data: {
    callback: (item) => {
      const dados = getDados(item)

      return dados.dt_acao ? utils.methods.formatDate(dados.dt_acao) : ''
    },
  },
  Ação: {
    callback: (item) => {
      const dados = getDados(item)

      return dados.tp_acao || ''
    },
  },
  Tipo: 'tipo',
  Equipe: {
    callback: (item) => {
      const dados = getDados(item)

      return dados.no_equipe || dados.nu_ine
        ? `${dados.no_equipe || ''}${
            dados.no_equipe && dados.nu_ine ? ' - ' : ''
          }${dados.nu_ine || ''}`
        : ''
    },
  },
  Profissional: {
    callback: (item) => {
      const dados = getDados(item)

      return dados.no_profissional || ''
    },
  },
}

export const infoHtml = ``
